import { useFetchApi, UseFetchDataResponse } from "./useFetchApi";

export type LiveSanityContentResponse<T> = {
  query?: string;
  result?: T;
};

export type UseLiveSanityContentResponse<T> = UseFetchDataResponse<
  LiveSanityContentResponse<T>
>;

export default function useLiveSanityContent<T>(
  query?: string
): UseLiveSanityContentResponse<T> {
  const sanityAPI = `https://${process.env.GATSBY_SANITY_PROJECT_ID}.apicdn.sanity.io/v1/data/query/${process.env.GATSBY_SANITY_DATASET}`;
  const params = new URLSearchParams({
    query: query || ""
  });

  return useFetchApi<LiveSanityContentResponse<T>>(
    query ? `${sanityAPI}?${params}` : undefined
  );
}
